import { dashboardConstants } from "../_constants";
import { dashboardServices } from "../_services";
import { alertActions } from ".";

export const dashboardActions = {
  getTopCardDashboard,
  getDailyJobRunTracker,
  getPieChartsDashboard,
  getDistinctConnections
};

function getTopCardDashboard() {
  return (dispatch) => {
    dispatch(request());
    dashboardServices.getTopCardDashboard().then(
      (dashboard) => {
        dispatch(success(dashboard));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dashboardConstants.GET_TOP_CARDS_DASHBOARD_REQUEST };
  }
  function success(dashboard) {
    return {
      type: dashboardConstants.GET_TOP_CARDS_DASHBOARD_SUCCESS,
      dashboard,
    };
  }
  function failure(error) {
    return {
      type: dashboardConstants.GET_TOP_CARDS_DASHBOARD_FAILURE,
      error,
    };
  }
}

function getPieChartsDashboard() {
  return (dispatch) => {
    dispatch(request());
    dashboardServices.getPieChartsDashboard().then(
      (dashboard) => {
        dispatch(success(dashboard));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dashboardConstants.GET_PIE_CHARTS_CARDS_DASHBOARD_REQUEST };
  }
  function success(dashboard) {
    return {
      type: dashboardConstants.GET_PIE_CHARTS_CARDS_DASHBOARD_SUCCESS,
      dashboard,
    };
  }
  function failure(error) {
    return {
      type: dashboardConstants.GET_PIE_CHARTS_CARDS_DASHBOARD_FAILURE,
      error,
    };
  }
}


function getDailyJobRunTracker(limit, connectionId, jobRunStatus) {
  return (dispatch) => {
    dispatch(request());
    dashboardServices.getDailyJobRunTracker(limit, connectionId, jobRunStatus).then(
      (dashboard) => {
        dispatch(success(dashboard));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dashboardConstants.GET_DAILY_JOB_RUN_TRACKER_REQUEST };
  }
  function success(dashboard) {
    return {
      type: dashboardConstants.GET_DAILY_JOB_RUN_TRACKER_SUCCESS,
      dashboard,
    };
  }
  function failure(error) {
    return {
      type: dashboardConstants.GET_DAILY_JOB_RUN_TRACKER_FAILURE,
      error,
    };
  }
}

function getDistinctConnections() {
  return (dispatch) => {
    dispatch(request());
    dashboardServices.getDistinctConnections().then(
      (connections) => {
        dispatch(success(connections));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dashboardConstants.GET_DISTINCT_CONNECTIONS_REQUEST };
  }
  function success(connections) {
    return {
      type: dashboardConstants.GET_DISTINCT_CONNECTIONS_SUCCESS,
      connections,
    };
  }
  function failure(error) {
    return {
      type: dashboardConstants.GET_DISTINCT_CONNECTIONS_FAILURE,
      error,
    };
  }
}







